import { render, staticRenderFns } from "./Cgroup.vue?vue&type=template&id=66fea85d&"
import script from "./Cgroup.vue?vue&type=script&lang=js&"
export * from "./Cgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports